module.exports = __webpack_public_path__ + "img/back-techno.a5530e12.jpg";